import { BrandItemType } from '@apps/config/brand.config';
import { useGetResponsive } from '@stack/helpers/lib/responsive';
import { TitleDivider } from '@stack/ui/components';

import BrandGroup from '../BrandGroup';

export const BrandFilter = (props: {
  title?: string;
  brands: BrandItemType[];
  webView?: boolean;
  showInnerTitle?: boolean;
  backgroundColor?: string;
  mobilePadding?: string;
}) => {
  const {
    brands,
    webView,
    title,
    showInnerTitle = false,
    backgroundColor,
    mobilePadding,
  } = props;

  const { isMobile } = useGetResponsive();
  const innerTitle = title || 'Popular Brands in Malaysia';

  return (
    <div
      style={{
        marginTop: isMobile ? '1rem' : 0,
        marginBottom: isMobile ? '1rem' : 0,
      }}
    >
      <TitleDivider title={title}>
        <BrandGroup
          brands={brands}
          webView={webView}
          isNewCar
          title={innerTitle}
          titleSize="20px"
          showTitle={showInnerTitle}
          backgroundColor={backgroundColor}
          mobilePadding={mobilePadding}
          renderAsPortal={true}
        />
      </TitleDivider>
    </div>
  );
};
